/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUserRolesResponse
 */
export interface ControlUserRolesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUserRolesResponse
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the ControlUserRolesResponse interface.
 */
export function instanceOfControlUserRolesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roles" in value;

    return isInstance;
}

export function ControlUserRolesResponseFromJSON(json: any): ControlUserRolesResponse {
    return ControlUserRolesResponseFromJSONTyped(json, false);
}

export function ControlUserRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserRolesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roles': json['roles'],
    };
}

export function ControlUserRolesResponseToJSON(value?: ControlUserRolesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roles': value.roles,
    };
}

